function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.955.879l2.166 2.076L14.5 17.168.879 2.955 3.045.879 14.5 12.832z"
});

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDI5IDE4Ij4KICA8cG9seWdvbiBwb2ludHM9IjU3OS45NTUgMzUyNC44NzkgNTgyLjEyMSAzNTI2Ljk1NSA1NjguNSAzNTQxLjE2OCA1NTQuODc5IDM1MjYuOTU1IDU1Ny4wNDUgMzUyNC44NzkgNTY4LjUgMzUzNi44MzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01NTQgLTM1MjQpIi8+Cjwvc3ZnPgo=";
export { SvgArrowDown as ReactComponent };